var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_vm._m(0),(_vm.data)?_c('Echart',{attrs:{"options":_vm.optionPie,"id":"stockQtyChart","width":"100%","height":"630px"}}):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-line",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"title1"},[_vm._v("实时库存分析")])])
}]

export { render, staticRenderFns }